import {
  AgxColumn,
  AgxTypography,
  AgxCollapsible,
} from '@urbanx/agx.ui-components2'

interface SubPagePanelProps {
  panelTitle?: string
  expandable?: boolean
  children: React.ReactNode
}

export function SubPagePanel({
  panelTitle,
  children,
  expandable = false,
}: SubPagePanelProps) {
  return (
    <>
      {expandable ? (
        <AgxCollapsible
          iconPosition="right"
          enableToggle={true}
          variant={'withDivider'}
          title={panelTitle || ''}
          content={<>{children}</>}
          customTitle=<AgxTypography
            id={`panelTitle_${panelTitle}`}
            type="title"
            size="large"
            color="var(--text-primary)"
          >
            {panelTitle}
          </AgxTypography>
        ></AgxCollapsible>
      ) : (
        <div className="panelContainer fill">
          <AgxColumn gap="spacing-3xl" fill>
            <div className="panelTitle">
              <AgxTypography
                id={`panelTitle_${panelTitle}`}
                type="body_ui_strong"
                size="medium"
              >
                {panelTitle}
              </AgxTypography>
            </div>
            <div className="panelTitleContainer">{children}</div>
          </AgxColumn>
        </div>
      )}
    </>
  )
}
